export default __webpack_public_path__ + "static/media/service_3.cfb925a9.jpg";